import React from 'react';
import { FormStateContextProvider } from './context/FormStateContext';

/**
 * @typedef {object} FormProviderWrapperProps
 * @property {Object} [form]
 * @property {(error: import('react-hook-form').FieldErrors) => void} [onError]
 * @property {React.ReactNode} [children]
 */

/**
 * @param {FormProviderWrapperProps} props
 */
const FormProviderWrapper = props => {
  const { form, onError, children } = props;
  return <FormStateContextProvider value={{ form, onError }}>{children}</FormStateContextProvider>;
};

export default FormProviderWrapper;
